<section class="ds-example-section">
  <header class="ds-example-section__header">
    <h3 class="ds-example-section__title">{{ title() }}</h3>
    @if (description()) {
      <p class="ds-example-section__desc">{{ description() }}</p>
    }
  </header>
  <div class="ds-example-section__preview">
    <ng-content />
  </div>
</section>
